import SimpleBarChartContent from './SimpleBarChartContent';

export default SimpleBarChartContent;
